import React, { useEffect, useState, useRef } from 'react';
import Navbar from '../../Components/Navbar/Navbar.jsx';
import DocumentListMeeting from '../../Components/DocumentListMeeting/DocumentListMeeting.jsx';
import Footer from '../../Components/Footer/Footer.jsx';


const MeetingDocumentPage = () => {

    useEffect(() => {
    
        const scrollToMiddle = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
    
        scrollToMiddle();
      }, []);
      
    return (
        <div>
            <div>
                <Navbar></Navbar>
            </div> 
            <div style={{marginTop: "120px"}}>
                <DocumentListMeeting></DocumentListMeeting>
            </div>
            <div style={{marginTop: "150px"}}>
                <Footer></Footer>
            </div>
        </div>
    );
};

export default MeetingDocumentPage;
